import { render, staticRenderFns } from "./SitemapPopup.vue?vue&type=template&id=228e047d&scoped=true"
import script from "./SitemapPopup.vue?vue&type=script&lang=js"
export * from "./SitemapPopup.vue?vue&type=script&lang=js"
import style0 from "./SitemapPopup.vue?vue&type=style&index=0&id=228e047d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e047d",
  null
  
)

export default component.exports